import {PolicyFilter} from 'modules/decisionsNext/api/types';

import {useIsDownMd} from 'utils/hooks/useMediaQuery';

import {CheckboxGroupBlock} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/CheckboxGroupBlock';
import {
  ConfidenceScore,
  confidenceScoreFilterRangeMap,
  confidenceScoreOptions,
  filterRangeToConfidenceScore,
} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/ConfidenceScoreBlock/constants';

type ConfidenceScoreBlockProps = {
  naicsScore: PolicyFilter['naicsSourceConfidenceScore'];
  setConfidenceScores: (policyFilter: Pick<PolicyFilter, 'naicsSourceConfidenceScore'>) => void;
  isIgnored?: boolean;
};

export const ConfidenceScoreBlock = ({naicsScore, setConfidenceScores, isIgnored}: ConfidenceScoreBlockProps) => {
  const isDownMd = useIsDownMd();
  const confidenceScores = (naicsScore || []).map(range => filterRangeToConfidenceScore(range));

  const handleConfidenceScoresChange = (scores: ConfidenceScore[]) =>
    setConfidenceScores({
      naicsSourceConfidenceScore: scores.map(score => confidenceScoreFilterRangeMap[score]),
    });

  return (
    <CheckboxGroupBlock
      row={!isDownMd}
      dataTestId='confidence-score-block'
      label='Confidence Score'
      options={confidenceScoreOptions}
      value={confidenceScores}
      onChange={handleConfidenceScoresChange}
      disabled={isIgnored}
    />
  );
};
